module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row panel panel-default confirmation-box"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Your Remediation Action has been submitted successfully.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                    Reference number:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                    " + _vm._s(_vm.remediation_action.remediation_action_id) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                    Lodgement date:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                    " + _vm._s(_vm.lodgement_date) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6567e1b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/remediation_action_submit_success.vue
// module id = 996
// module chunks = 0